import { ApiEndpointSpecification } from './types';
import { HttpMethod } from '../http-request';
import * as Helpers from '../api-request-helpers';
import * as Types from '../types';
import { DEVICE_CHANNELS } from './url-constants';

type DeviceChannelDataEndpointSpecification = ApiEndpointSpecification;
export const DeviceChannelDataEndpointSpecification: DeviceChannelDataEndpointSpecification = {
    url: DEVICE_CHANNELS,
    method: HttpMethod.GET,
    requestParamsSchemaName: 'DeviceChannelDataRequestParams',
    requestBodySchemaName: 'DeviceChannelDataRequestBody',
    okResponseSchemaName: 'DeviceChannelDataOkResponse',
    notOkResponseSchemaName: 'GenericNotOkResponse',
    authenticated: true,
    version: 3.0,
};

export const invokeDeviceChannelData = Helpers.makeApiRequestFn<
    Types.DeviceChannelDataRequestParams,
    Types.DeviceChannelDataRequestBody,
    Types.DeviceChannelDataOkResponse
>(DeviceChannelDataEndpointSpecification);
